<div class="min-h-screen w-full flex items-center justify-center p-4 
            overflow-auto bg-[linear-gradient(3.33deg,_#E3D7FF_-19.66%,_#F3F4F8_78.02%)]">

  <div class="w-full max-w-sm">
    <div class="rounded-2xl bg-white shadow-xl ring-1 ring-black/5">
      <div class="px-6 py-8 sm:px-8">
        <div class="mx-auto mb-4 flex items-center justify-center">
          <app-ivy-face-animated></app-ivy-face-animated>
        </div>

        <h2 class="text-center text-xl font-bold">Let’s talk about how this works</h2>

        <div class="mt-4 relative">
          <div
            class="text-xs text-gray-700 leading-5 space-y-3 border border-[#E3D7FF] rounded-lg p-4 max-h-64 overflow-y-auto"
            id="consent-text"
          >
            <p>
              By choosing to use IVY Health Assistant and submitting content, Personal Data, or other information to IVY
              Health Assistant, you confirm that you have read and agreed to this Privacy consent and supplemental Privacy
              notice, as well as our
              <a class="underline text-violet-700 hover:text-violet-800"
                 href="https://legal.stringhealth.ai/privacy-policy.html" target="_blank" rel="noopener">Privacy Policy</a>
              and
              <a class="underline text-violet-700 hover:text-violet-800"
                 href="https://legal.stringhealth.ai/terms-of-use.html" target="_blank" rel="noopener">Terms of Service</a>.
            </p>
            <p>
              Personal Data, as used in our Privacy Policy and this Privacy Notice, means any information that directly or indirectly
              relates to an identified or identifiable individual; it is synonymous with “personal information” or “user data”
              and includes Sensitive Personal Data. If you do not agree to this Privacy Consent and supplemental Privacy notice,
              then you should not use the IVY Health Assistant service.
            </p>
            <p>
              The information, responses, and results provided by IVY Health Assistant service are strictly for general informational
              purposes only and are not intended to replace medical or other professional advice, treatment, or diagnosis. Always
              seek the advice of a qualified health and medical provider with any questions you have regarding a medical condition.
              Never disregard professional medical advice, or delay in seeking it, because of something you read from IVY Health Assistant
              service. IVY Health Assistant service makes no representation or warranty as to the accuracy, completeness, or reliability
              of the information provided by IVY Health Assistant service. IVY expressly disclaims any and all liability, express or implied,
              for omissions from or errors arising from use of IVY Health Assistant.
            </p>
            <p>
              To provide information, responses, and results to you, IVY Health Assistant service uses its own algorithms and artificial
              intelligence and machine learning systems provided by OpenAI, L.L.C. (“OpenAI”). Those algorithms and systems are rapidly
              evolving, and given the probabilistic nature of machine learning, use of this systems may, in some situations, result in output
              that is incorrect, incomplete, or does not accurately reflect real people, places, situations, or facts. You should evaluate
              the accuracy of any output as appropriate for your use case, including by using a human review of the output. It is also important
              to note that even where there are no inaccuracies, the information provided by IVY Health Assistant service is based on general
              information and cannot take into account your specific circumstances, health history, or other relevant factors. Therefore, we
              strongly recommend that you consult with a qualified health provider before making any decisions regarding your or any other
              person’s health based on information generated by the IVY Health Assistant service.
            </p>
            <p>
              You should be aware that any information, including communications, content, Personal Data, including Sensitive Personal Data,
              you provide through, or that is collected by IVY Health Assistant service will be transmitted to OpenAI, our artificial intelligence
              service provider, for processing in order to provide our services to you. String Health may record, disclose, transmit, process,
              and use any such information, including communications, to provide our services as further described in our Privacy Policy and this
              supplemental Privacy notice. OpenAI retains submitted data and information for the period of 30 days by default and may record,
              process, transmit, and use any such information, including communications, in conjunction with providing our services to you.
              For more information on the privacy practices of OpenAI, please visit the
              <a class="underline text-violet-700 hover:text-violet-800" href="https://openai.com/policies" target="_blank" rel="noopener">
                Terms &amp; Policies
              </a> page.
            </p>
          </div>
        </div>


        <form [formGroup]="consentForm" (ngSubmit)="onSubmit()" class="mt-6">
          <label class="flex items-start gap-3 text-sm text-gray-900">
            <input id="accept" type="checkbox" formControlName="accept"
                   class="mt-1 h-4 w-4 rounded-full border-gray-300 text-black focus:ring-black"/>
            <span>I have read and agree to the terms and conditions.<span class="text-rose-600">*</span></span>
          </label>

          <p *ngIf="consentForm.controls.accept.touched && consentForm.controls.accept.invalid"
             class="mt-2 text-xs text-rose-600">
            You must agree to continue.
          </p>

          <button type="submit"
                  [disabled]="consentForm.invalid || isLoading"
                  class="mt-5 inline-flex w-full items-center justify-center rounded-full bg-black px-4 text-sm font-semibold text-white transition disabled:cursor-not-allowed disabled:opacity-60 h-[45px]">
            {{ isLoading ? 'Processing…' : 'I CONSENT' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
